// Nine Lives '84 - keyboard input.
//
// Turns held keys into the per-tick command word the simulation consumes.
// Jump, action and sound are edge-triggered (one per key press); left,
// right and down repeat while held.

import { K_ACTION, K_DOWN, K_JUMP, K_LEFT, K_PAUSE, K_RIGHT, K_SOUND, K_UP } from '../sim/constants';

export const DEFAULT_KEYMAP: Record<string, number> = {
  ArrowLeft: K_LEFT,
  ArrowRight: K_RIGHT,
  ArrowUp: K_JUMP | K_UP,
  Space: K_JUMP | K_UP,
  ArrowDown: K_DOWN,
  KeyX: K_ACTION,
  ControlLeft: K_ACTION,
  ControlRight: K_ACTION,
  KeyS: K_SOUND,
  KeyP: K_PAUSE,
};

const EDGE_KEYS = K_JUMP | K_ACTION | K_SOUND | K_PAUSE;

export class Keyboard {
  private held = 0;
  private pressed = 0;

  constructor(
    target: Window | HTMLElement = window,
    private readonly keymap: Record<string, number> = DEFAULT_KEYMAP,
  ) {
    target.addEventListener('keydown', this.onDown as EventListener);
    target.addEventListener('keyup', this.onUp as EventListener);
    if (typeof window !== 'undefined') {
      window.addEventListener('blur', () => {
        this.held = 0;
      });
    }
  }

  private onDown = (e: KeyboardEvent): void => {
    const bit = this.keymap[e.code];
    if (bit === undefined) return;
    e.preventDefault();
    if (e.repeat) return;
    this.held |= bit;
    this.pressed |= bit & EDGE_KEYS;
  };

  private onUp = (e: KeyboardEvent): void => {
    const bit = this.keymap[e.code];
    if (bit === undefined) return;
    this.held &= ~bit;
  };

  /** The command word for the next tick; consumes edge-triggered presses. */
  poll(): number {
    const keys = (this.held & ~EDGE_KEYS) | this.pressed;
    this.pressed = 0;
    return keys;
  }
}
